import axios from "axios";
import {environment} from "../../environments/environment";
import { authTokenStorage } from "../utils/auth-token-storage";
import { URLS } from "./app-urls";

export const Api = axios.create({baseURL: environment.baseURL});

// Endpoints whose response body is allowed to carry a new `access` token.
// Any other endpoint renews the session only via the `new_access_token`
// response header (set by the backend's RefreshTokenMiddleware), never by a
// same-named field that happens to appear in unrelated JSON. Also reused by
// auth-context.tsx's 470 interceptor to identify auth-bootstrap calls.
const AUTH_TOKEN_BODY_ENDPOINTS = [
  `${URLS.AUTH}register_session/`,
  `${URLS.AUTH}local_fallback/`,
];

export const isAuthTokenBodyEndpoint = (url?: string): boolean => {
  if (!url) return false;
  return AUTH_TOKEN_BODY_ENDPOINTS.some((endpoint) => url.includes(endpoint));
};

export const handleAuthRequest = (config: any) => {
  const token = authTokenStorage.get();
  if (token) {
      config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

export const handleAuthResponse = (response: any) => {
  const bodyToken = isAuthTokenBodyEndpoint(response.config?.url) ? response.data?.access : null;
  const newToken = response.headers["new_access_token"] || bodyToken || null;
  if (newToken && newToken !== authTokenStorage.get()) {
      authTokenStorage.set(newToken);
  }
  return response;
};

export const handleAuthResponseError = async (error: any) => {
  if (error.response?.status === 401) {
      console.error(error);
      authTokenStorage.clear();
      const event = new CustomEvent("unauthorized-event", { detail: { reason: "session_expired" } });
      window.dispatchEvent(event);
  }

  return Promise.reject(error);
};

Api.interceptors.request.use(handleAuthRequest, (error) => Promise.reject(error));
Api.interceptors.response.use(handleAuthResponse, handleAuthResponseError);

export default Api;
